// @ts-strict-ignore
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { LMColumnsBaseComponent, LMElementLayoutType } from './lm-columns-base.component';
import { LMConditionUtilService } from '@utils/lm-condition-util.service';
import { LMFormLayoutService } from '@form/services/lm-form-layout.service';
import { LMLayoutUtilDirective } from './lm-layout-util.directive';
import { LMLoggerService } from '@app/services';

@Component({
  selector: 'lm-columns-undistributed',
  templateUrl: 'lm-columns-undistributed.component.html',
  styleUrls: [ 'lm-columns-undistributed.component.scss' ],
  providers: [ LMLayoutUtilDirective, LMFormLayoutService ],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class LMColumnsUndistributedComponent extends LMColumnsBaseComponent implements OnInit {

  @Input() lmParagraphLayoutInfo: LMParagraphLayoutInfo;

  constructor(
    protected lmConditionUtilService: LMConditionUtilService,
    protected lmFormLayoutService: LMFormLayoutService,
    protected lmLoggerService: LMLoggerService,
    protected changeDetectorRef: ChangeDetectorRef
  ) {
    super(lmConditionUtilService, lmFormLayoutService, lmLoggerService, changeDetectorRef);
    this.subLayoutType = LMElementLayoutType;
  }

  ngOnInit() {
    super.ngOnInit();
    if (this.lmFormLayoutService.columnsAreImplicit(this.layoutObject)) {
      this.columns = this.lmFormLayoutService.buildImplicitColumns(this.layoutObject, this.model);
    } else {
      this.columns = this.layoutObject.columns;
    }
  }

  public onFieldEvent(event) {
    this.fieldEvent.emit(event);
  }
}
